<h1 mat-dialog-title i18n>Search for a User</h1>
<form [formGroup]="formInputs">
	<div mat-dialog-content class="main-content px-3">
		<div class="row">
			<div class="col-6">
				<mat-form-field appearance="standard" class="w-100">
					<input matInput type="text" placeholder="Search by email (exact, case sensitive)" i18n-placeholder formControlName="userId" />

					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.controls.userId"
						[type]="'text'"
					></mat-error>
				</mat-form-field>
			</div>

			<div class="col-6">
				<div class="col-12 text-right mb-4 mt-2">
					<button
						[disabled]="formInputs.invalid"
						type="submit"
						mat-flat-button
						color="primary"
						i18n
						(click)="findUsers()"
						class="col-12 col-sm-auto mr-sm-2"
					>Search</button>

					<button
						type="button"
						mat-flat-button
						color="warn"
						i18n
						(click)="close($event)"
						title="Close"
						i18n-title
						class="col-12 col-sm-auto mb-2 mb-sm-0 reset-button"
					>Close</button>
				</div>
			</div>
		</div>

		<div class="row" *ngIf="users && users.length">
			<div class="col-12">
				<mat-card class="p-0">
					<div class="table-responsive">
						<table
							mat-table
							[dataSource]="users"
							class="w-100"
							matSort
							matSortActive="{{sortColumn}}"
							matSortDisableClear
							matSortDirection="{{sortOrder}}"
							multiTemplateDataRows
							aria-label="List of available users">

							<ng-container matColumnDef="firstname">
								<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef i18n>First name</th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									<span title="First Name" i18n-title type="button">{{row.firstname}}</span>
								</td>
							</ng-container>

							<ng-container matColumnDef="lastname">
								<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef i18n>Last name</th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									<span title="Last Name" i18n-title type="button">{{row.lastname}}</span>
								</td>
							</ng-container>

							<ng-container matColumnDef="email">
								<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef i18n>Email</th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									<button title="Email" i18n-title class="button-link" type="button" (click)="viewUserDetails(row)">{{row.email}}</button>
								</td>
							</ng-container>

							<tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
							<tr mat-row *matRowDef="let row; columns: tableColumns; let i = dataIndex;"></tr>
						</table>
					</div>
				</mat-card>
			</div>
		</div>
	</div>
</form>
